import React, { useState, useEffect, useContext } from 'react';
import { Typography, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { AntTabs, AntTab } from '../tabs_style';
import Alert from '@mui/material/Alert';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español

export default function ResumenRoActual({ nombre, apellido, modulo }) {
  const [tabIndex, setTabIndex] = React.useState(0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [rows, setRows] = useState([
    {
      id: 1,
      inicio: null,
      final: null,
      errors: {
        inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
        final: { fechaVacia: false, invalidFormat: false, cleared: false }
      }
    }
  ]);

  const data = [
    { description: 'COTIZACIONES SEGÚN SISTEMA', amount: 'L. 0.00' },
    { description: 'OTROS', amount: 'L. 0.00', msj: 'MÁS' },
    { description: 'REBAJA DE COTIZACIONES', amount: 'L. 0.00', msj: 'MENOS' },
    { description: 'OTROS', amount: 'L. 0.00', msj: 'MENOS' },
    { description: 'VALOR NETO DE COTIZACIONES', amount: 'L. 0.00' },
    { description: 'INTERESES', amount: 'L. 0.00', msj: "MÁS" },
    { description: 'COTIZACIONES MAS INTERESES ANTES DE APLICAR EL R.O.', amount: 'L. 0.00' },
    { description: 'APLICACIÓN DE OFICIO DEL', amount: '0.00', msj: "MENOS" },
    { description: 'OTRAS APLICACIONES DE OFICIO', amount: 'L. 0.00', msj:"MENOS"},
    { description: 'INTERESES A REBAJAR POR LA  APLICACIÓN DE OFICIO', amount: 'L. 0.00', msj:"MENOS"},
    { description: 'TOTAL COTIZACIONES E INTERESES', amount: 'L. 0.00'},
    { description: 'FACTOR DE RESCATE', amount: 'L. 0.00', msj:"POR"},
    { description: 'MONTO DEL BENEFICIO', amount: 'L. 0.00'},
    { description: 'VALORES EN CONTRA', amount: 'L. 0.00'},
  ];

  function CustomDatePickerTabla({ rowId, field, label, selectedDate, errors, ...props }) {
    const today = dayjs();

    useEffect(() => {
      if (errors.cleared) {
        const timeout = setTimeout(() => {
          setRows(rows.map(row => {
            if (row.id === rowId) {
              return {
                ...row,
                errors: {
                  ...row.errors,
                  [field]: { ...row.errors[field], cleared: false }
                }
              };
            }
            return row;
          }));
        }, 1500);

        return () => clearTimeout(timeout);
      }
      return () => { };
    }, [errors.cleared, rowId, field]);

    const handleKeyDown = (event) => {
      event.preventDefault();
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoItem>
          <DatePicker
            disabled
            format={"DD/MM/YYYY"}
            value={selectedDate}
            views={['year', 'month', 'day']}
            label={label}
            slotProps={{
              field: { clearable: true },
              textField: {
                disabled: true,
                helperText: errors.fechaVacia ? `Seleccione la ${label}` :
                  errors.invalidFormat ? "Formato de fecha incorrecto" :
                    (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" :
                      errors.invalidRange ? "La Fecha Final no puede ser menor que la Fecha Inicio" : null),
                error: errors.fechaVacia || errors.invalidFormat || errors.invalidRange,
                onKeyDown: handleKeyDown,
              },
            }}
            maxDate={today}
            {...props}
          />
        </DemoItem>
        {errors.cleared && (
          <Alert
            sx={{ position: 'absolute', bottom: 0, right: 0 }}
            severity="success"
          >
            Fecha Borrada!
          </Alert>
        )}
      </LocalizationProvider>
    );
  }

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Resumen</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Tasas Por Año" />
                <AntTab label="Monto Del Beneficio" />
                <AntTab label="Datos" />
                <AntTab label="Retiros De Oficio" />
                <AntTab label="Cálculos" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0}
            {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresRoActual')}
            {tabIndex === 2 && navigate('/Separaciones/TasasRoActual')}
            {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioRoActual')}
            {tabIndex === 4 && navigate('/Separaciones/ROdespues13demayo2014')}
            {tabIndex === 5 && navigate('/Separaciones/RetirosOficioRoActual')}
            {tabIndex === 6 && navigate('/Separaciones/CalculosRoActual')}
          </Box>
        </Container>
      </Grid>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nombreparticipante"
                    label="Nombre Del Participante"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="identidad"
                    label="Número De Tarjeta De Identidad"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="cotizante"
                    label="Cotizante"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="edadactual"
                    label="Edad Actual"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="dependencia"
                    label="Dependencia"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="ramo"
                    label="Ramo"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="tiemposolicitado"
                    label="Tiempo De Servicio Solicitado"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="fechasolicitud"
                    label="Fecha De Solicitud"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="tasainteres"
                    label="Tasa De Interés Utilizada"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>
          </CardContent>
        </Card>
      </Box>

      <Box marginTop={3} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Container>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6"><strong>Detalle De Períodos</strong></Typography>
              </div>
            </Container>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>#</strong></TableCell>
                    <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Inicio</strong></TableCell>
                    <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Final</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell style={{ textAlign: 'center', fontSize: 16 }}>
                        <label><strong>{row.id}</strong></label>
                      </TableCell>
                      <TableCell>
                        <CustomDatePickerTabla
                          rowId={row.id}
                          field='inicio'
                          label="Fecha Inicio"
                          selectedDate={row.inicio}
                          errors={row.errors.inicio}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomDatePickerTabla
                          rowId={row.id}
                          field='final'
                          label="Fecha Final"
                          selectedDate={row.final}
                          errors={row.errors.final}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

      <Box marginTop={3} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Container>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6"><strong>Detalle De Cálculos</strong></Typography>
              </div>
            </Container>
            <TableContainer component={Paper}>
              <Table aria-label="cotizaciones table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontSize: 20, backgroundColor: '#eeeeee' }}><b></b></TableCell>
                    <TableCell style={{ fontSize: 20, backgroundColor: '#eeeeee' }}><b>Descripción</b></TableCell>
                    <TableCell style={{ fontSize: 20, textAlign: 'center', backgroundColor: 'lightgrey' }}><b>Monto</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row, index) => (
                    <TableRow key={row.description}>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          backgroundColor: index % 2 === 0 ? 'white' : '#eeeeee',
                          width: '10px',
                          textAlign: 'center'
                        }}
                      >
                        {row.msj}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ backgroundColor: index % 2 === 0 ? 'white' : '#eeeeee', }}
                      >
                        <b>{row.description}</b>
                      </TableCell>
                      <TableCell
                        style={{ textAlign: 'center' }}
                        sx={{ backgroundColor: index % 2 === 0 ? 'white' : 'lightgray' }}
                      >
                        {row.amount}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Typography sx={{ padding: 2 }}>
              FUNDAMENTO LEGAL: ARTICULO 73 DE BENEFICIO DE TRANSFERENCIA DE VALORES ACTUARIALES
              O SEPARACIÓN DEL SISTEMA, EFECTIVO A PARTIR DEL 13 DE MAYO 2014
              "Observación: A través del presente resumen, completadas las firmas correspondientes, la División de
              Beneficios recomienda la continuación del procedimiento para la aprobación y pago de este beneficio"
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
